































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../../sw-extended-vue';

@Component
export default class SwTreeDropdownUnit extends SwExtendedVue {

  cssPrefix = 'sw-tree-dropdown-unit';

  @Prop({ type: Boolean, required: false, default: false })
  disabled: boolean;
}
